export const InspectionLink = (inspectionId, tab = 0) => {
  return `/inspections/${inspectionId}?tab=${tab}`;
};

export const InspectionSubjectLink = (inspectionSubjectId, tab = 0) => {
  return `/inspection_subjects/${inspectionSubjectId}?tab=${tab}`;
};

export const PlaceLink = (placeId, tab = 0) => {
  return `/places/${placeId}?tab=${tab}`;
};

export const PlacesLink = () => {
  return '/places';
};

export const InspectionsLink = () => {
  return '/inspections';
};

export const DashboardLink = () => {
  return '/dashboard';
};

export const InspectionSubjectsLink = () => {
  return '/inspection_subjects';
};

export const ProfileLink = () => {
  return '/profile';
};

export const LoginLink = () => {
  return '/users/login';
};

export const RegisterLink = () => {
  return '/users/register';
};

export const ForgotPasswordLink = () => {
  return '/users/forgot_password';
};

export const TemplatesLink = () => {
  return '/templates';
};

export const TemplateLink = (templateId) => {
  return `/templates/${templateId}`;
};

export const GoogleLink = (place) => {
  const query = encodeURIComponent(`${place.street} ${place.zipCode} ${place.city}`);
  return `https://www.google.com/maps?q=${query}`;
};

export const UsersLink = () => {
  return '/users';
};

export const BillingLink = () => {
  return '/billing';
};


export const SpacesLink = () => {
  return '/spaces';
};

export const WebsiteLink = () => {
  return import.meta.env.VITE_WEBSITE_URL;
};

export const TermsLink = () => {
  return import.meta.env.VITE_WEBSITE_URL + '/terms';
};

export const PaymentTermsLink = () => {
  return import.meta.env.VITE_WEBSITE_URL + '/payment-terms';
};

export const PrivacyPolicyLink = () => {
  return import.meta.env.VITE_WEBSITE_URL + '/privacy-policy';
};
